import { render, staticRenderFns } from "./FormAddWardenPopup.vue?vue&type=template&id=06ea4028"
import script from "./FormAddWardenPopup.vue?vue&type=script&lang=js"
export * from "./FormAddWardenPopup.vue?vue&type=script&lang=js"
import style0 from "./FormAddWardenPopup.vue?vue&type=style&index=0&id=06ea4028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports